import type { CustomIconProps } from '../CustomIcon';

export const StampIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='m15.687 9.345.696.28-.696-.28ZM17 14.001l-.038.75H17v-.75Zm5.5 4v.75a.75.75 0 0 0 .75-.75h-.75Zm-20 0h-.75c0 .415.336.75.75.75v-.75Zm5.5-4v.75h.038L8 14Zm1.313-4.656-.696.28.696-.28Zm7.937-3.344a4.75 4.75 0 0 0-4.75-4.75v1.5a3.25 3.25 0 0 1 3.25 3.25h1.5Zm-.867 3.624c.393-.977.867-2.142.867-3.624h-1.5c0 1.158-.361 2.076-.759 3.065l1.392.559Zm-.633 2.377c0-.777.272-1.477.633-2.377l-1.392-.56c-.344.859-.741 1.824-.741 2.937h1.5Zm1.288 1.25c-.262-.013-.606-.099-.864-.289-.221-.163-.424-.431-.424-.961h-1.5c0 1.014.436 1.727 1.034 2.168.561.415 1.217.557 1.678.58l.076-1.498Zm-.038 1.5h3.5v-1.5H17v1.5Zm3.5 0c.69 0 1.25.56 1.25 1.25h1.5a2.75 2.75 0 0 0-2.75-2.75v1.5Zm1.25 1.25v2h1.5v-2h-1.5Zm.75 1.25h-20v1.5h20v-1.5Zm-19.25.75v-2h-1.5v2h1.5Zm0-2c0-.69.56-1.25 1.25-1.25v-1.5a2.75 2.75 0 0 0-2.75 2.75h1.5Zm1.25-1.25H8v-1.5H4.5v1.5Zm4.75-2.75c0 .53-.203.798-.424.961-.258.19-.601.276-.864.29l.076 1.498c.46-.024 1.117-.166 1.679-.58.597-.442 1.033-1.155 1.033-2.17h-1.5Zm-.633-2.377c.361.9.633 1.6.633 2.377h1.5c0-1.113-.397-2.078-.741-2.936l-1.392.559ZM7.75 6c0 1.482.474 2.647.867 3.624l1.392-.56c-.397-.988-.759-1.906-.759-3.064h-1.5Zm4.75-4.75a4.75 4.75 0 0 0-4.75 4.75h1.5a3.25 3.25 0 0 1 3.25-3.25v-1.5ZM4.5 20.002h16v2h-16z'
        fill='#76706D'
      />
    </svg>
  );
};
